import {
  Box,
  InputAdornment,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import {
  borderTextbox,
  greyColor6,
  whiteColor,
} from "../../configs/styles/muiThemes";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { allowOnlyEnglish } from "../../utils/helper";

function ReportSearch({
  minWidth,
  label,
  placeholder,
  name,
  value,
  onChange,
  startIcon,
  icon,
  maxLength,
  inputType,
  isError,
  errorMsg,
  helperText,
  autoFocus,
  inputRef,
  onKeyUp,
  onBlur,
  disabled,
  isDashboardInput,
  onSearchClick,
  labelStyles,
  radius
}) {
  return (
    <Box display={"flex"} flexDirection={"column"}>
      {label && (
        <Typography
          variant="body2"
          component="label"
          fontSize={{ xs: 12, md: 13 }}
          color={greyColor6}
          fontWeight={400}
          mb="4px !important"
          sx={{ display: "inline", ...labelStyles }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          borderTop: borderTextbox,
          borderBottom: borderTextbox,
          borderLeft: borderTextbox,
          borderRight: borderTextbox,
          borderRadius: radius ? radius : "10px",
          backgroundColor: whiteColor,
          width: "100%",
          height: "34px",
          display: "flex",
          alignItems: "center",
          color: "#64748B",
        }}
      >
        <TextField
          variant="standard"
          required={true}
          fullWidth
          name={name}
          disabled={disabled}
          value={value}
          onBlur={onBlur}
          autoFocus={autoFocus}
          onChange={({ target }) => {
            const finalValue = allowOnlyEnglish(target.value);
            onChange(finalValue);
          }}
          onKeyUp={onKeyUp}
          placeholder={placeholder}
          inputRef={inputRef}
          sx={{
            fontSize: 12,
            color: "#64748B",
          }}
          InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end" sx={{ cursor: "pointer" }}>
            //       {icon}
            //     </InputAdornment>
            //   ),
            style: {
              padding: "7px 10px",
              // color: grey,
              color: "#64748B",
              fontSize: 12,
              fontWeight: 500,
            },
            disableUnderline: true,
          }}
          inputProps={{ maxLength: maxLength }}
          type={inputType}
        />
        {radius && (
          <IconButton
            aria-label="search"
            onClick={(e) => {
              e.preventDefault();
              onSearchClick();
            }}
          >
            <SearchRoundedIcon sx={{ fontSize: "18px", color: "#64748B" }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export default ReportSearch;
